/*
 * @Author: Yuan Cong <email: wso2848303@163.com> <tel: 15821618224>
 * @Date: 2021-01-05 15:47:11
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-03-12 11:37:30
 * @Description: 页头类型
 * @FilePath: /hsylc2021/src/utils/process.js
 */
export default {
  STU_APPLY: 'STU_APPLY'
};
